import { EventEmitter } from "events";
import "whatwg-fetch";
import sessionStore from "./SessionStore";
import { checkStatus, errorHandler } from "./helpers";

class SubMeterStore extends EventEmitter {
  getAll(applicationID, pageSize, offset, orderBy, desc ,match, callbackFunc) {
    fetch("/api/subMeter?limit="+pageSize+"&offset="+offset+"&applicationID="+applicationID+"&sortField="+orderBy+"&order="+desc+"&match="+match, {headers: sessionStore.getHeader()})
      .then(checkStatus)
      .then((response) => response.json())
      .then((responseData) => {
        if(typeof(responseData.subMeter) === "undefined") {
          callbackFunc(0, []);
        } else {
          callbackFunc(responseData.totalCount, responseData.subMeter);
        }
      })
      .catch(errorHandler);
  }


  getSubMeter(subMeterID, callbackFunc) {
    fetch("/api/subMeter/"+subMeterID, {headers: sessionStore.getHeader()})
      .then(checkStatus)
      .then((response) => response.json())
      .then((responseData) => {
        callbackFunc(responseData);
      })
      .catch(errorHandler);
  }

  createSubMeter(subMeter, callbackFunc) {
    fetch("/api/subMeter", {method: "POST", body: JSON.stringify(subMeter), headers: sessionStore.getHeader()})
      .then(checkStatus)
      .then((response) => response.json())
      .then((responseData) => {
        callbackFunc(responseData);
      })
      .catch(errorHandler);
  }

  updateSubMeter(subMeterID, subMeter, callbackFunc) {
    fetch("/api/subMeter/"+subMeterID, {method: "PUT", body: JSON.stringify(subMeter), headers: sessionStore.getHeader()})
      .then(checkStatus)
      .then((response) => response.json())
      .then((responseData) => {
        callbackFunc(responseData);
      })
      .catch(errorHandler);
  }

  deleteSubMeter(subMeterID, callbackFunc) {
    fetch("/api/subMeter/"+subMeterID, {method: "DELETE", headers: sessionStore.getHeader()})
      .then(checkStatus)
      .then((response) => response.json())
      .then((responseData) => {
        callbackFunc(responseData);
      })
      .catch(errorHandler);
  }
}

const subMeterStore = new SubMeterStore();

export default subMeterStore;



// WEBPACK FOOTER //
// ./src/stores/SubMeterStore.js